"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurancePolicyCoverageType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var InsurancePolicyCoverageType_Factory = /** @class */ (function () {
    function InsurancePolicyCoverageType_Factory() {
    }
    InsurancePolicyCoverageType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    InsurancePolicyCoverageType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return InsurancePolicyCoverageType_Factory;
}());
exports.InsurancePolicyCoverageType_Factory = InsurancePolicyCoverageType_Factory;
